import TextObject from '../Hotspot/TextObject';

export const createAndRenderLabel = (objectPlacementTarget, props) => {
	const marker = new TextObject(props);
	marker.addToScene(objectPlacementTarget);
	return marker;
};
